document.addEventListener('DOMContentLoaded', () => {
    const langFlags = document.querySelectorAll('.language-flag');
    const langOptions = document.querySelectorAll('li[lang]');
    const langDropdown = document.querySelector('.localization-form__select');

    if (!langFlags || !langOptions || !langDropdown) {
        return;
    }

    langFlags.forEach((langFlag) => {
        langFlag.addEventListener('click', () => {
            langFlag.classList.toggle('open');
            langFlag.setAttribute('aria-expanded', (langFlag.classList.contains('open') ? 'true' : 'false'));
        });
    })

    langOptions.forEach((option) => {
        option.addEventListener('click', () => {
            selectLanguage(option);
        });

        option.addEventListener('keyup', (e) => {
            if (e.key === 'Enter') {
                selectLanguage(option);
            }
        });
    });

    document.addEventListener('click', (e) => {
        if (!e.target.closest('.language-flag')) {
            langFlags.forEach((langFlag) => {
                langFlag.classList.remove('open');
                langFlag.setAttribute('aria-expanded', 'false');
            });
        }
    });

    const selectLanguage = (option) => {
        langDropdown.value = option.lang;
        langDropdown.dispatchEvent(new Event('change'), { bubbles: true });
    }
});

// Preload the slide images the card swatches point to as soon as a card is hovered, so the swap feels instant
const swatchPreloaded = new WeakSet();

document.addEventListener('pointerover', (e) => {
    const card = e.target.closest('product-card');

    if (!card || swatchPreloaded.has(card)) {
        return;
    }

    swatchPreloaded.add(card);
    card.querySelectorAll('.card-swatch[data-media-id]').forEach((swatch) => {
        card.querySelector(`slideshow-slide[slide-id="${swatch.dataset.mediaId}"] img[loading="lazy"]`)?.removeAttribute('loading');
    });
});

// Touch: press and hold a swatch previews the image (pointerenter/leave), so keep the long-press menu away
document.addEventListener('contextmenu', (e) => {
    if (e.target.closest('.card-swatch')) {
        e.preventDefault();
    }
});

// Horizon leaves its view-transition markers on a card after back navigation from the cache; clear them or the next card transition gets a duplicate name
window.addEventListener('pageshow', (e) => {
    if (!e.persisted) {
        return;
    }

    document.querySelectorAll('[data-view-transition-type], [data-view-transition-triggered]').forEach((el) => {
        el.removeAttribute('data-view-transition-triggered');
        el.removeAttribute('data-view-transition-type');
    });
});
